import { Injectable, Output, EventEmitter} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { ChatModel } from './ct'
import { Chat } from './chat';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class ChatService {
    @Output() getUnReadMessageCounter: EventEmitter<any> = new EventEmitter();
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allChat(data): Promise<Chat> {
        return this.httpmanagerService.HttpPost('schat/allchat',JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    chatHistory(id): Promise<Chat> {
        return this.httpmanagerService.HttpGet('schat/chathistory', id).then(data => {
            return data;
        })
    }
    sendMessage(data): Promise<Chat> {
        return this.httpmanagerService.HttpPost('schat/create',JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    clearChatHistory(id): Promise<Chat> {
        return this.httpmanagerService.HttpPost('schat/clearchathistory',{}, id).then(data => {
            return data;
        })
    }
    unreadMessageCount(id): Promise<Chat> {
        return this.httpmanagerService.HttpPost('schat/unreadcounter',{}, id).then(data => {
            if(data.data.length > 0)
            {
                this.getUnReadMessageCounter.emit(data.data[0].unreadcount);
            }
            else
            {
                this.getUnReadMessageCounter.emit(0);
            }
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/chat/chat.service.ts